import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import { required, requiredIf, maxLength, minLength, email, numeric, sameAs, minValue } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import CONFIG from "@/assets/js/config.custom.js";
import store from '@/store';

const convertNumberService = new ConvertNumService();

export default {
  name: "EmployeeCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      campusName: [],
      adminNo: store.state.user.admin_no,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      employee_flag: CONFIG.EMPLOYEE_FLAG,
      adminRole: null,
      religionArr: null,
      teacherTypeArr: null,
      nrcNameJson: null,
      naingJson: null,
      districtList: [],
      naingList: [],
      nrcno: null,
      roleNameErr: false,

      employeeImage: "",
      nrcFrontImage: "",
      nrcBackImage: "",
      signImage: "",

      employeeData: {
        campus_id: store.state.user.admin_no == '0001' ? '' : store.state.user.campus_id,
        employee_flag: CONFIG.EMPLOYEE_FLAG.STAFF,
        teacher_type_id: '',
        role: '',
        role_name: '',
        name: '',
        password: '',
        confirm_password: '',
        dob: '',
        nationality: '',
        religion: '',
        marital_status: '',
        gender: '',
        father_name: '',
        email: '',
        phone1: '',
        phone2: '',
        contact_address: '',
        permanent_address: '',
        edu_background: '',
        other_certificate: '',
        work_experience: '',
        join_date: '',
        resign_date: '',
        login_id: store.state.user.id,
        parent_chat_enable: CONFIG.TEACHER_PARENT_CHAT ? CONFIG.TEACHER_PARENT_CHAT.DISABLE : 0,
        position_id: 0,
        employment_type: CONFIG.EMPLOYMENT_TYPE.FULL_TIME,
        nrc_number: '',
        ferry_status: 0,
      },

      nrc_number: "",
      nrckey: "",
      selectedNrcName: "",
      selectedNrcNaing: "",
      nrcName: [],
      previewUrl: null,
      employeeFile: null,
      emailExists: null,

      submitted: false,
      disabled: false,
      isLoading: false,

      parent_chat_enable: CONFIG.TEACHER_PARENT_CHAT ? CONFIG.TEACHER_PARENT_CHAT.ENABLE : 1,
      parent_chat_disable: CONFIG.TEACHER_PARENT_CHAT ? CONFIG.TEACHER_PARENT_CHAT.DISABLE : 0,
      positionOptions: [],
      employmentTypeOptions: Object.entries(CONFIG.EMPLOYMENT_TYPE_TXT).map(([id, text]) => ({
        id: Number(id),
        text,
      })),
      config: CONFIG,
    };
  },

  validations: {
    employeeData: {
      campus_id: {
        required,
      },
      employee_flag: {
        required,
      },
      name: {
        required,
        maxLength: maxLength(100),
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(20),
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs('password')
      },
      dob: {
        required,
        maxLength: maxLength(100),
      },
      gender: {
        required,
      },
      father_name: {
        required,
        maxLength: maxLength(50),
      },
      teacher_type_id: {
        required: requiredIf(function () {
          return this.adminNo != '0001' && this.employeeData.employee_flag != this.employee_flag.STAFF;
        })
      },

      parent_chat_enable: {
        required: requiredIf(function () {
          return this.employeeData.employee_flag == this.employee_flag.TEACHER;
        })
      },
      marital_status: {
        required,
      },
      nrc_number: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6)
      },
      nationality: {
        required,
        maxLength: maxLength(100),
      },
      edu_background: {
        maxLength: maxLength(1000)
      },
      other_certificate: {
        maxLength: maxLength(1000)
      },
      work_experience: {
        maxLength: maxLength(1000)
      },
      join_date: {
        required,
      },
      email: {
        maxLength: maxLength(50),
        email
      },
      phone1: {
        required,
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11)
      },
      phone2: {
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11)
      },
      contact_address: {
        required,
        maxLength: maxLength(1000)
      },
      permanent_address: {
        maxLength: maxLength(1000)
      },
      position_id: {
        required,
        numeric,
        minValue: minValue(1)
      },
      role: {
        required: requiredIf(function () {
          return this.employeeData.employee_flag == this.employee_flag.STAFF;
        })
      },
      role_name: {
        required: requiredIf(function () {
          return this.employeeData.employee_flag == this.employee_flag.STAFF
            && String(this.employeeData.role) === CONFIG.ROLE.ID.OTHER;
        }),
        maxLength: maxLength(100)
      },
      ferry_status: {
        required: requiredIf(function () {
          return this.employeeData.employee_flag == this.employee_flag.TEACHER;
        })
      },
    },
  },

  computed: {
    isValidPosition() {
      return this.positionOptions.map(pos => pos.id).includes(Number(this.employeeData.position_id));
    }
  },

  methods: {
    isRoleOther() {
      return this.employeeData.role == CONFIG.ROLE.ID.OTHER;
    },

    getAdminRole() {
      const roles = CONFIG.ROLE.TXT;
      let result = [
        {
          id: 0,
          text: 'Select'
        }
      ];
      Object.entries(roles).forEach(([id, key]) => {
        result.push({
          id: id,
          text: key
        });
      });
      this.adminRole = result;
    },

    campusNameAction() {
      if (this.adminNo == '0001') {
        axios.get('campus/campusName')
          .then(res => {
            this.campusName = res.data;
          }).catch((error) => {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            this.isLoading = false;
          });
      }
      else {
        this.campusName = this.$store.state.user.campus_master.campus_name;
        this.employeeData.campus_id = this.$store.state.user.campus_master.id;
      }
    },

    getReligion() {
      const result = [{
        id: 0,
        text: 'Select'
      }];
      Object.entries(CONFIG.RELIGION).forEach(([id, key]) => {
        result.push({
          id: id,
          text: key
        });
      });
      this.religionArr = result;
    },

    getNrcData() {
      this.nrcno = CONFIG.NRC.CITY;
      this.naingJson = CONFIG.NRC.NAING;
      this.nrcNameJson = CONFIG.NRC.TOWNSHIP;
    },

    getTeacherType() {
      axios.get('getTeacherType')
        .then(res => {
          this.teacherTypeArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getPositions() {
      axios.get('position/type', 
        {
          params: { type: this.employeeData.employee_flag } 
        })
        .then(res => {
          this.positionOptions = res.data.map(pos => {
            return {
              id: pos.id,
              text: pos.position_name
            }
          });
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    onChange(event) {
      var optionText = event.target.value;
      var convertNumberService = new ConvertNumService();
      var optionValue = convertNumberService.convertMm2Eng(optionText);
      if (optionValue) {
        this.nrckey = optionText;
        const placeholder = document.getElementById('nrc_placeholder');
        placeholder.style.display = 'none'
      } else {
        this.nrckey = optionValue;
      }
      this.selectedNrcName = "";
      this.districtList = this.changeNrcName(optionValue);
    },

    changeNrcName(value, nrcName) {
      nrcName = this.nrcNameJson[value];
      return nrcName;
    },

    onChangeNrcName(event) {
      var optionValue = event.target.value;
      if (!optionValue) {
        this.selectedNrcNaing = ""
        this.employeeData.nrc_number = ""
      }
      this.naingList = this.naingJson;
    },

    checkNRC() {
      if (
        this.nrckey !== undefined &&
        this.selectedNrcName !== undefined &&
        this.selectedNrcNaing !== undefined &&
        this.employeeData.nrc_number !== ""
      ) {
        return true;
      } else if (
        this.nrckey == undefined &&
        this.selectedNrcName == undefined &&
        this.selectedNrcNaing == undefined &&
        this.employeeData.nrc_number == ""
      ) {
        return true;
      } else return false;
    },

    mergeNRC() {
      return convertNumberService.convertEng2Mm(
        this.nrckey + "/" + this.selectedNrcName + this.selectedNrcNaing + this.employeeData.nrc_number
      );
    },

    chooseFiles(id) {
      document.getElementById(id).click();
    },

    uploadImage(id) {
      const inputfile = document.getElementById(id).files[0];
      if (inputfile) {
        if (inputfile.type.includes("image/")) {
          // validate for sign image
          if (id == 'signImage' && inputfile.type !== "image/png") {
            this.$notification.error("Only PNG file type allowed!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          if (inputfile.type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.readAsDataURL(inputfile);
          reader.onloadend = () => {
            if (reader.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
            } else {
              this.$set(this, id, reader.result);
            }
          };
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    removeImg(img) {
      this.$set(this, img, '');
      document.getElementById(img).value = '';
    },

    openFileInput() {
      this.$refs.fileInput.click();
    },

    triggerFileInput() {
      // Only open file selector if no file is selected yet
      if (!this.previewUrl) {
        this.openFileInput();
      }
    },

    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (!selectedFile) return;

      const allowedTypes = ['.zip'];
      const fileType = selectedFile.name.substring(selectedFile.name.lastIndexOf('.')).toLowerCase();

      if (selectedFile.size > 10485760) {
        this.$notification.error("Zip File too large", {
          timer: 3,
          position: "bottomCenter",
        });
        this.$refs.fileInput.value = '';
      } else if (allowedTypes.includes(fileType)) {
        this.employeeFile = selectedFile;
        this.previewUrl = URL.createObjectURL(selectedFile);
      } else {
        this.$notification.error("File not supported!", {
          timer: 3,
          position: "bottomCenter",
        });
        this.$refs.fileInput.value = '';
      }
    },

    removeFile() {
      this.employeeFile = null;
      this.previewUrl = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.oldCertifiFile = null;
    },

    async create() {
      this.submitted = true;
      const isStaff = this.employeeData.employee_flag == this.config.EMPLOYEE_FLAG.STAFF;
      if (this.$v.$invalid || this.checkNRC() == false || this.emailExists) {
        return;
      }

      const isRoleMissing = !this.employeeData.role || this.employeeData.role == 0 || this.employeeData.role == '';
      const isOtherRole = this.isRoleOther();

      if (isStaff && isOtherRole && !this.employeeData.role_name) {
        this.roleNameErr = true;
      } else {
        this.roleNameErr = false;
      }
      if (this.$v.$invalid ||
        (isStaff && isRoleMissing) ||
        (isStaff && isOtherRole && this.roleNameErr)
      ) {
        return;
      }

      this.isLoading = true;
      this.disabled = true;

      const formData = new FormData();
      formData.append('employee_flag', this.employeeData.employee_flag);
      formData.append('teacher_type_id', this.employeeData.teacher_type_id);
      formData.append('name', this.employeeData.name);
      formData.append('password', this.employeeData.password);
      formData.append('dob', this.employeeData.dob);
      formData.append('nationality', this.employeeData.nationality);
      formData.append('religion', this.employeeData.religion);
      formData.append('marital_status', this.employeeData.marital_status);
      formData.append('gender', this.employeeData.gender);
      formData.append('father_name', this.employeeData.father_name);
      formData.append('email', this.employeeData.email);
      formData.append('phone1', this.employeeData.phone1);
      formData.append('phone2', this.employeeData.phone2);
      formData.append('contact_address', this.employeeData.contact_address);
      formData.append('permanent_address', this.employeeData.permanent_address);
      formData.append('edu_background', this.employeeData.edu_background);
      formData.append('other_certificate', this.employeeData.other_certificate);
      formData.append('work_experience', this.employeeData.work_experience);
      formData.append('join_date', this.employeeData.join_date);
      formData.append('resign_date', this.employeeData.resign_date);
      formData.append('campus_id', this.employeeData.campus_id);
      formData.append('login_id', this.employeeData.login_id);
      formData.append('nrc_number', this.mergeNRC());
      formData.append('profileImage', this.employeeImage);
      formData.append('nrcFrontImage', this.nrcFrontImage);
      formData.append('signImage', this.signImage);
      formData.append('nrcBackImage', this.nrcBackImage);
      formData.append('employee_file', this.employeeFile);
      formData.append('parent_chat_enable', this.employeeData.parent_chat_enable);
      formData.append('position_id', this.employeeData.position_id);
      formData.append('employment_type', this.employeeData.employment_type);
      formData.append('ferry_status', this.employeeData.ferry_status == null ? '' : this.employeeData.ferry_status);
      formData.append('role', this.employeeData.role ?? '');
      formData.append('role_name', this.employeeData.role_name ?? '');

      axios.post("/employee/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.isLoading = false;
          if (response.data.success == true) {
            this.$notification.success("Employee Registered Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({
              name: "employeeList",
            });
          } else {
            this.isLoading = false;
            this.disabled = false;
            this.$notification.error(response.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch((error) => {
          this.disabled = false;
          this.isLoading = false;

          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
            return;
          }

          const message = error.response?.data?.message
            || (error.response?.data?.errors
              ? Object.values(error.response.data.errors).flat().join(', ')
              : null)
            || error.message
            || 'Failed to create employee.';

          this.$notification.error(message, {
            timer: 3,
            position: "bottomCenter",
          });
          console.log("Employee Create API Error", error);
        });
    },
  },

  async mounted() {
    this.getReligion();
    this.getNrcData();
    this.getTeacherType();
    this.getPositions();
    this.getAdminRole();
    this.campusNameAction();
  },
};
